import { OverlayPanel } from "primeng/primeng";
import { IServiceDataLoader } from "../../../../interfaces/utils.interface";
import { SearchColumn } from "../../search-utils";
import { SearchContentComponent } from "../search-content/search-content.component";
import {
  Component,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  OnDestroy
} from "@angular/core";
import { Subscription } from "rxjs/internal/Subscription";

@Component({
  selector: "search-overlay",
  templateUrl: "./search-overlay.component.html",
  styles: [
    `
    .ui-overlaypanel-content {
        padding: 0 !important;
    }`
  ]
})
export class SearchOverlayComponent implements OnDestroy {
  private _subscriptions: Subscription[] = [];
  @ViewChild(OverlayPanel) overlay: OverlayPanel;
  @ViewChild(SearchContentComponent) searchContent: SearchContentComponent;
  @Input() searchTitle: string;
  @Input() service: IServiceDataLoader<any>;
  @Input() columns: Array<SearchColumn>;
  @Output() onClose = new EventEmitter();
  @Input() value: any;

  ngOnDestroy() {
    this._unsubscribe();
  }

  hide() {
    this.overlay.hide();
  }

  show(event) {
    this._subscribe();
    this.overlay.toggle(event);
  }

  private _unsubscribe() {
    this._subscriptions.forEach((subscr: Subscription) => {
      subscr.unsubscribe();
    });

    this._subscriptions = [];
  }

  private _subscribe() {
    this._subscriptions.push(
      this.overlay.onShow.subscribe(() => {
        this.searchContent.focus();
      })
    );

    this._subscriptions.push(
      this.overlay.onHide.subscribe(() => {
        this.onClose.emit(event);
        this._unsubscribe();
      })
    );
  }
}
